
export class RecursionHelperLogic {


    constructor(
        public entries: any[],
        public recursionAttribute: string = "parentDtoId",
        public entityIdAttribute: string = "id",
        public entityNameAttribute: string = "name",
        public treeAttributeLabel: string = "label",
        public treeAttributeEntry: string = "entry",
        public treeAttributeChildren: string = "children"
    ) {

    }

    /**
     * Extract tree information with the given attributes.
     */
    public extractTree() : any[] {

        const tree: any[] = [];

        const rootEntries = this.getChildEntries(null);
        const processed: Map<number, boolean> = new Map<number, boolean>();

        for (let rootEntry of rootEntries) {
            this.extractTreeInternal(rootEntry, tree, processed);
        }
        return tree;

    }

    /**
     * This routine will extract the information recursively.
     * @param entry
     * @param parentNode
     * @param processed
     * @protected
     */
    protected extractTreeInternal(entry: any, parentNode: any[], processed: Map<number, boolean>) {

        // check if this node was already processed
        if (processed.has(entry[this.entityIdAttribute])) {
            // this entry was already processed, so we have some kind of recursion
            return;
        }

        // store information that this entry was already processed
        processed.set(entry[this.entityIdAttribute], true);

        // add entry to node
        const newNodeEntry = {};
        newNodeEntry[this.treeAttributeEntry] = entry;
        newNodeEntry[this.treeAttributeLabel] = entry[this.entityNameAttribute];

        const childEntries = this.getChildEntries(entry);

        if (childEntries.length > 0) {
            newNodeEntry[this.treeAttributeChildren] = [];

            for (let childEntry of childEntries) {
                this.extractTreeInternal(childEntry, newNodeEntry[this.treeAttributeChildren], processed);
            }

        }

        parentNode.push(newNodeEntry);
    }

    /**
     * Get parent entries.
     * @param parent
     * @protected
     */
    public getChildEntries(parent: any) : any[] {

        const children: any[] = [];

        for (let entry of this.entries) {

            if (!parent) {
                if (!entry[this.recursionAttribute]) {
                    children.push(entry);
                }
            } else if (parent[this.entityIdAttribute] == entry[this.recursionAttribute]) {
                children.push(entry);
            }

        }

        return children;

    }


}